<template>
  <v-bottom-sheet v-model="isActive" persistent>
    <v-card>
      <div class="modal-header mb-4">
        <p class="title">Excluir tarefa</p>
      </div>

      <p class="confirm-text mb-2">Você tem certeza que deseja excluir esta tarefa?</p>

      <div class="task-info">
        <div class="status d-flex justify-center align-center mb-2">
          <p class="description">Status atual</p>
          <p class="status-badge ml-3" :class="colorClasses[task.status]">{{ statusLabels[task.status] }}</p>
        </div>

        <p v-if="task.status === 'finished'" class="finished-text mb-2">Tarefa concluída</p>

        <p class="text-description mb-2">{{ task.description }}</p>

        <div class="time-info">
          <p>Tempo</p>
          <span>2h 22m ・ </span>
          <span>Total</span>

          <v-divider class="mx-2" vertical style="height: 18px"></v-divider>

          <span>{{ `${formatTime(task.estimated_time)} ・ ` }}</span>
          <span>Estimado</span>
        </div>
      </div>

      <div class="modal-footer">
        <v-btn class="custom-btn cancel" elevation="0" @click="close">Cancelar</v-btn>
        <v-btn class="custom-btn delete" elevation="0" @click="confirmDelete">Excluir</v-btn>
      </div>
    </v-card>
  </v-bottom-sheet>
</template>

<script>
export default {
  name: 'ModalDeleteTask',
  emits: ['close'],
  props: {
    isActive: {
      type: Boolean,
      required: true
    },
    task: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      statusLabels: {
        paused: 'Em Pausa',
        working: 'Trabalhando',
        finished: 'Finalizada'
      },
      colorClasses: {
        created: 'theme-indigo',
        paused: 'theme-indigo',
        working: 'theme-orange',
        finished: 'theme-green'
      }
    };
  },
  methods: {
    close() {
      this.$emit('close');
    },
    async confirmDelete() {
      this.$emit('confirm-delete');
    },
    formatTime(time) {
      if (!time) return '';
      const [hours, minutes] = time.split(':');
      return `${hours}h ${minutes}m`;
    }
  }
};
</script>

<style lang="scss" scoped>
.v-card {
  padding: 16px 16px 24px 16px;

  p {
    margin-bottom: 0;
  }

  .modal-header {
    .title {
      color: #2d3748;
      font-size: 18px;
      font-weight: 600;
      margin-bottom: 0;
      text-align: center !important;
      width: 100%;
    }
  }

  .confirm-text {
    color: #4a5568;
    font-weight: 600;
    font-size: 16px;
    text-align: center;
  }

  .task-info {
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 12px;
    text-align: center;
    font-size: 14px;

    .status {
      .description {
        color: #718096;
        font-weight: 400;
        font-size: 14px;
      }

      .status-badge {
        background-color: #f0fff4;
        border-radius: 4px;
        color: #48bb78;
        font-size: 14px;
        font-weight: 700;
        padding: 2px 8px;

        &.theme-indigo {
          background-color: #ebf4ff;
          color: #667eea;
        }

        &.theme-orange {
          background-color: #fffaf0;
          color: #ed8936;
        }

        &.theme-green {
          background-color: #f0fff4;
          color: #48bb78;
        }
      }
    }

    .finished-text {
      color: #2f855a;
      font-weight: 600;
      font-size: 14px;
    }

    .text-description {
      color: #4a5568;
      font-weight: 700;
      font-size: 16px;
    }

    .time-info {
      span {
        color: #718096;
        font-weight: 600;
        font-size: 16px;
      }

      p {
        color: #718096;
        font-weight: 400;
        font-size: 14px;
      }
    }
  }

  .modal-footer {
    display: flex;
    justify-content: space-between;
    margin-top: 18px;

    .custom-btn {
      border-radius: 8px;
      font-size: 16px;
      font-weight: 600;
      height: 40px;
      letter-spacing: 0.3px;
      text-transform: none;
      width: 48%;

      &.delete {
        color: #fff;
        background-color: #f56565;
      }

      &.cancel {
        border: 1px solid #e2e8f0;
        background-color: #fff;
        color: #4a5568;
      }
    }
  }
}
</style>
